import { InjectionToken } from '@angular/core';

export type FeatureFlagsState = { isFlagEnabled(flagName: string): boolean; }

export const FEATURE_FLAGS_STATE = new InjectionToken<FeatureFlagsState>('Feature flag state')